module.exports = __webpack_public_path__ + "static/media/profile.7da0f143.scss";


//////////////////
// WEBPACK FOOTER
// ./src/pages/styles/profile.scss
// module id = 379
// module chunks = 0